<template>
  <div>
    <spinner-overlay
      :show-overlay="showOverlay"
      :show-spinner="showSpinner"
    />
    <v-alert
      v-if="checkoutErrorMessage"
      type="error"
      outlined
    >
      <p>Could not create a checkout session</p>
      <p>
        Please email support at
        <support-link :subject="checkoutErrorMessage" />
      </p>
    </v-alert>
    <v-row>
      <v-col
        cols="12"
        class="text-center"
      >
        <h2 class="mb-4 text-uppercase">
          A pricing level for everyone
        </h2>
      </v-col>
    </v-row>
    <v-row justify="space-around">
      <v-col
        v-for="subscriptionPlan in availableSubscriptionPlans"
        :key="subscriptionPlan.id"
        xl="3"
      >
        <available-subscription-plan
          :subscription-plan="subscriptionPlan"
          :disabled="showOverlay"
          @priceSelected="handlePriceSelected"
        />
      </v-col>
      <v-col
        v-if="isStandardBusiness"
        xl="3"
      >
        <enterprise-subscription-plan />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AvailableSubscriptionPlan from '@/components/AvailableSubscriptionPlan'
import EnterpriseSubscriptionPlan from '@/components/EnterpriseSubscriptionPlan'
import SupportLink from '@/components/SupportLink'
import SpinnerOverlay from '@/components/SpinnerOverlay.vue'

export default {
  name: 'SelectSubscriptionPlan',
  components: {
    AvailableSubscriptionPlan,
    EnterpriseSubscriptionPlan,
    SupportLink,
    SpinnerOverlay
  },
  data: function () {
    return {
      showOverlay: true,
      showSpinner: true,
      checkoutErrorMessage: false
    }
  },
  computed: {
    returnUrl() {
      return window.location.href
    }
  },
  beforeCreate() {
    this.dispatchActions([
      'get_availableSubscriptionPlans',
      'get_activePrices'
    ]).then(async () => {
      this.showOverlay = false
      this.showSpinner = false
    })
    this.mapStates(['availableSubscriptionPlans'])
    this.mapGetters(['isStandardBusiness'])
  },
  methods: {
    async handlePriceSelected(price) {
      this.showSpinner = true
      this.showOverlay = true

      try {
        const { url } = await this.$api.checkout({
          user: this.$store.state.user.uid,
          checkoutData: {
            allow_promotion_codes: true,
            price: price.id,
            success_url: this.returnUrl,
            cancel_url: this.returnUrl
          }
        })
        this.showSpinner = false
        window.location.assign(url)
      } catch (error) {
        this.checkoutErrorMessage = error.message
        this.showOverlay = false
        this.showSpinner = false
        throw error
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.v-card {
  height: 100%;
}
</style>
